import { useMutation } from "@apollo/client/react"; import React, { useState, useEffect, useMemo } from "react";

import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { Grid } from "@mui/material";
import toast from 'react-hot-toast';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import moment from "moment";
import { CREATE_PROFESIONAL_MONITOREO } from "../../../../../data/graphQL/mutations/Profesionales/createProfesionalMonitoreo";

export function MonitoreoDialog({
  open,
  handleCloseDialog,
  readOnly = false,
  monitoreoSelected,
  profesionalMonitoreoCombos,
  reclamos,
  monitoreos,
  idProfesional,
  fetchProfesionalMonitoreos
}) {
  const [loading, setLoading] = useState(false);
  const [monitoreo, setMonitoreo] = useState([]);
  const [reclamosFiltered, setReclamosFiltered] = useState(reclamos);

  const handleChange = (name, value) => {
    setMonitoreo((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const [createProfesionalMonitoreo] = useMutation(CREATE_PROFESIONAL_MONITOREO);
  const adaptMonitoreoToServiceInput = (monitoreo) => {
    return {
      idProfesional: idProfesional,
      idProfMonitoreoVisitas: {
        id: monitoreo?.idProfMonitoreoVisitas,
        resta: profesionalMonitoreoCombos.visitas.find((x) => x.id === monitoreo?.idProfMonitoreoVisitas)?.resta
      },
      observacionVisitas: monitoreo?.observacionVisitas,
      idProfMonitoreoCompletitud: {
        id: monitoreo?.idProfMonitoreoCompletitud,
        resta: profesionalMonitoreoCombos.completitud.find((x) => x.id === monitoreo?.idProfMonitoreoCompletitud)?.resta
      },
      observacionCompletitud: monitoreo?.observacionCompletitud,
      idProfMonitoreoEntrenamiento: {
        id: monitoreo?.idProfMonitoreoEntrenamiento,
        resta: profesionalMonitoreoCombos.entrenamiento.find((x) => x.id === monitoreo?.idProfMonitoreoEntrenamiento)?.resta
      },
      observacionEntrenamiento: monitoreo?.observacionEntrenamiento,
      comentariosGenerales: monitoreo?.comentariosGenerales,
      reclamos: reclamosFiltered.map((x) => x?.idGestionReclamoNavigation?.idGestionReclamo)
    };
  };

  useEffect(() => {
    let reclamosFiltrados = [];
    if (!monitoreoSelected) {
      const fechaAltaNuevoMonitoreo = monitoreo?.fechaMonitoreo ? moment(monitoreo.fechaMonitoreo) : moment();
      let ultimoMonitoreo = monitoreos[0];
      const fechaProximoMonitoreoParsed = moment(ultimoMonitoreo?.idProfesionalNavigation?.fechaProximoMonitoreo);
      let monitoreoIndex = 0;
      let fechaUltimoMonitoreo = ultimoMonitoreo?.fechaMonitoreo;

      // Calcular el porcentaje de vigencia
      let vigencia = !!fechaUltimoMonitoreo && !!fechaProximoMonitoreoParsed ?
        moment().diff(moment(fechaUltimoMonitoreo), "days") /
        fechaProximoMonitoreoParsed.diff(fechaUltimoMonitoreo, "days") :
        1;

      while (vigencia < 0.7 && monitoreoIndex < monitoreos.length - 1) {
        monitoreoIndex++;
        ultimoMonitoreo = monitoreos[monitoreoIndex];
        fechaUltimoMonitoreo = ultimoMonitoreo?.fechaMonitoreo;
        // Calcular el porcentaje de vigencia
        vigencia = !!fechaUltimoMonitoreo && !!fechaProximoMonitoreoParsed ?
          moment().diff(moment(fechaUltimoMonitoreo), "days") /
          fechaProximoMonitoreoParsed.diff(fechaUltimoMonitoreo, "days") :
          1;
      }

      // Determinar la fecha de inicio del filtro
      const fechaInicioFiltro =
        ultimoMonitoreo?.fechaMonitoreo && monitoreos.length > 1 ?
          moment(ultimoMonitoreo?.fechaMonitoreo) :
          moment(0);

      // Determinar la fecha de fin del filtro
      const fechaFinFiltro = fechaAltaNuevoMonitoreo;

      // Filtrar los reclamos
      reclamosFiltrados = reclamos.filter((reclamo) => {
        const fechaReclamo = moment(reclamo?.idGestionReclamoNavigation?.fechaRegistro || reclamo?.fechaRegistro);
        return (
          fechaReclamo.isSameOrAfter(fechaInicioFiltro) &&
          fechaReclamo.isSameOrBefore(fechaFinFiltro) &&
          reclamo?.idGestionReclamoNavigation?.correspondeProfesional
        );
      });
    } else {
      reclamosFiltrados = monitoreo?.profesionalMonitoreoReclamos || [];
    }

    setReclamosFiltered(reclamosFiltrados);
  }, [monitoreoSelected, monitoreo, reclamos, monitoreos]);

  useEffect(() => {
    setMonitoreo(monitoreoSelected);
  }, [monitoreoSelected]);

  const handleAcceptUpdate = async () => {
    try {
      setLoading(true);
      const input = adaptMonitoreoToServiceInput(monitoreo);
      const { data } = await createProfesionalMonitoreo({
        variables: { input }
      });

      if (data?.createProfesionalMonitoreo) {
        toast.success("Monitoreo creado con éxito.");
        handleCloseDialog();
      } else {
        toast.error("No se pudo crear el monitoreo?. Intente nuevamente.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocurrió un error al crear el monitoreo?.");
    } finally {
      fetchProfesionalMonitoreos();
      setLoading(false);
    }
  };

  const updatedFields = useMemo(() => {
    return structuredClone(fields).
      map((input) => {
        const updatedInput = { ...input };
        switch (input.name) {
          case 'idProfMonitoreoVisitas':
            updatedInput.options = profesionalMonitoreoCombos.visitas;
            break;
          case 'idProfMonitoreoCompletitud':
            updatedInput.options = profesionalMonitoreoCombos.completitud;
            break;
          case 'idProfMonitoreoEntrenamiento':
            updatedInput.options = profesionalMonitoreoCombos.entrenamiento;
            break;
          default:
            break;
        }
        if (!!readOnly) {
          updatedInput.disabled = true;
        }
        return updatedInput;
      });
  }, [
    readOnly,
    monitoreo,
    monitoreoSelected,
    profesionalMonitoreoCombos]
  );

  const columns = generateColumnsDefaultConfiguration([
    {
      headerName: '#',
      field: 'idGestionReclamo',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idGestionReclamoNavigation?.numeroReclamo || row?.numeroReclamo}
          </div>);
      }
    },
    {
      headerName: 'Fecha Ocurrencia',
      field: 'fechaOcurrencia',
      type: 'datetime',
      flex: 120,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {moment(row.idGestionReclamoNavigation?.fechaOcurrencia || row?.fechaOcurrencia).format('DD/MM/YYYY HH:mm')}
          </div>);
      }
    },
    {
      headerName: 'Estado',
      field: 'estado',
      type: 'string',
      flex: 170,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idGestionReclamoNavigation?.idEstadoReclamoNavigation?.descripcion || row?.idEstadoReclamoNavigation?.descripcion}
          </div>);
      }
    },
    {
      headerName: 'Usuario',
      field: 'usuario',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        const nombreCompleto = `${row.idGestionReclamoNavigation?.idUsuarioCreadorNavigation?.nombre || row?.idUsuarioCreadorNavigation?.nombre} ${row.idGestionReclamoNavigation?.idUsuarioCreadorNavigation?.apellido || row?.idUsuarioCreadorNavigation?.apellido}`;
        return (
          <div>
            {nombreCompleto}
          </div>);
      }
    },
    {
      headerName: 'Descripción',
      field: 'descripcion',
      type: 'string',
      flex: 100,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div>
            {row.idGestionReclamoNavigation?.descripcion || row?.descripcion}
          </div>);
      }
    }],
    true);

  return (
    <CustomDialog
      title="Agregar Monitoreo"
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Agregar monitoreo"
      acceptLoading={loading}
      acceptDisabled={loading || !!readOnly}>

      <Grid container spacing={3}>
        {updatedFields.map((input, index) =>
          <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== "item" ? 12 : 0 }}>
            {
              input.type === "reclamos" ?
                <DataGridGenerico
                  columns={columns}
                  totalCount={reclamosFiltered.length}
                  rows={reclamosFiltered}
                  toolbar={false}
                  maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)} /> :


                <RenderInputByTypeMobile
                  key={`input-${input.name}-index-${index}`}
                  input={input}
                  handleChange={handleChange}
                  value={monitoreo?.[input.name]} />

            }
          </Grid>
        )}
      </Grid>
    </CustomDialog>);

}

const fields = [
  {
    displayName: 'Reclamos',
    name: 'reclamos',
    type: 'info_inline',
    col: 12
  },
  {
    displayName: 'Reclamos',
    name: 'reclamos',
    type: 'reclamos',
    disabled: false,
    col: 12
  },
  {
    displayName: 'Visitas',
    name: 'visitas',
    type: 'info_inline',
    col: 12
  },
  {
    displayName: 'Cumplimiento de visita por plan',
    name: 'idProfMonitoreoVisitas',
    type: 'select',
    disabled: false,
    col: 6
  },
  {
    displayName: 'Datos',
    name: 'observacionVisitas',
    type: 'long_string',
    col: 6
  },
  {
    displayName: 'Calidad',
    name: 'Calidad',
    type: 'info_inline',
    col: 12
  },
  {
    displayName: 'Calidad de completitud de registro',
    name: 'idProfMonitoreoCompletitud',
    type: 'select',
    disabled: false,
    col: 6
  },
  {
    displayName: 'Datos',
    name: 'observacionCompletitud',
    type: 'long_string',
    disabled: false,
    col: 6
  },
  {
    displayName: 'Asistencia',
    name: 'Asistencia',
    type: 'info_inline',
    col: 12
  },
  {
    displayName: 'Cumplimiento de plan de entrenamiento',
    name: 'idProfMonitoreoEntrenamiento',
    type: 'select',
    disabled: false,
    col: 6
  },
  {
    displayName: 'Datos',
    name: 'observacionEntrenamiento',
    type: 'long_string',
    disabled: false,
    col: 6
  },
  {
    displayName: 'Comentarios generales',
    name: 'comentariosGenerales',
    type: 'long_string',
    disabled: false,
    col: 12
  }];